import numeral from 'numeral';

if (numeral.locales.th === undefined) {
  // load a locale
  numeral.register('locale', 'th', {
    delimiters: {
      thousands: ',',
      decimal: '.',
    },
    abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'b',
      trillion: 't',
    },
    ordinal: (number) => (number === 1 ? 'er' : 'ème'),
    currency: {
      symbol: '฿',
    },
  });
}

// switch between locales
numeral.locale('th');

export default numeral;
